var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5C48.464 5 61 17.536 61 33C61 48.464 48.464 61 33 61C17.536 61 5 48.464 5 33Z",
    fill: "#F7FFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0837 27.7499L41.167 23.6666M43.5003 21.3333L41.167 23.6666L43.5003 21.3333ZM32.2887 32.5449C32.8911 33.1393 33.3699 33.847 33.6977 34.6272C34.0255 35.4074 34.1957 36.2447 34.1985 37.091C34.2014 37.9373 34.0368 38.7757 33.7142 39.5581C33.3917 40.3405 32.9176 41.0514 32.3192 41.6498C31.7208 42.2482 31.0099 42.7223 30.2275 43.0448C29.4451 43.3674 28.6067 43.532 27.7604 43.5291C26.9141 43.5263 26.0768 43.3561 25.2966 43.0283C24.5164 42.7005 23.8087 42.2216 23.2143 41.6193C22.0455 40.4091 21.3987 38.7882 21.4133 37.1058C21.4279 35.4233 22.1028 33.814 23.2925 32.6242C24.4822 31.4345 26.0916 30.7597 27.774 30.7451C29.4564 30.7305 31.0773 31.3772 32.2875 32.5461L32.2887 32.5449ZM32.2887 32.5449L37.0837 27.7499L32.2887 32.5449ZM37.0837 27.7499L40.5837 31.2499L44.667 27.1666L41.167 23.6666L37.0837 27.7499Z",
    stroke: "#2A870E",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
    fill: "#F9F5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key_icon.bb02723d2fdb7364a1f8c9b87477a9d4.svg";
export { ForwardRef as ReactComponent };